module.exports = __webpack_public_path__ + "img/safety_signs.png";